import { initConfigUnsafe } from '@cian/config/browser';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { init as initHttpApi } from '@cian/http-api/browser';
import { initLogger } from '@cian/logger/browser';
import { registry } from '@cian/mf-registry/browser';
import { init as initTelemetry } from '@cian/telemetry/browser';
import { init as initWeb } from '@cian/web/browser';

import { type IApplicationContext } from 'shared/types/applicationContext';

export type RawApplicationContext = Pick<
  IApplicationContext,
  'config' | 'httpApi' | 'logger' | 'microfrontendsRegistry'
>;

export function initDependencies(): RawApplicationContext {
  const config = initConfigUnsafe();

  const logger = initLogger();
  const httpApi = initHttpApi();
  initTelemetry();
  initWeb();
  initGlobalBehaviors();

  return {
    config,
    httpApi,
    logger,
    microfrontendsRegistry: registry(),
  };
}
